window._ = window._ = require('lodash');
window.AOS = require("aos/dist/aos.js");
window.$ = window.jQuery = require("jquery"); //v3.7.0
// require("popper.js/dist/umd/popper.min.js");
window.bootstrap = require("bootstrap/dist/js/bootstrap.min.js"); //v4.6.2
// require("bootstrap/dist/js/bootstrap.bundle.min.js");
require("moment/moment.js");